
















































import { Component, Mixins } from 'vue-property-decorator';
import Modal from './property-categories.modal.vue';
import TableMixin from '@/mixins/table.mixin';

@Component({
  components: { Modal },
})
export default class PropertyCategoriesShell extends Mixins(TableMixin) {
  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    { label: 'GENERAL.NAME', name: 'name', sortable: true },
    { label: 'GENERAL.CODE', name: 'code', sortable: true },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];
}
